// upload.js
import axios from 'axios';
import Compressor from 'compressorjs';
/**
 * 图片上传用这个
 * @type {AxiosInstance}
 */
const fileAxios = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 180000, // 3min
  headers: {
      "Content-Type": "multipart/form-data",
      "Authorization": localStorage.getItem('token')
  }
});

export const upload = (option, onProgress) => {
  return new Promise((resolve, reject) => {
      const params = new FormData();
      params.append(option.filename, option.file, option.file.name); //通过append向form对象添加数据

      const config = {
        onUploadProgress: progressEvent => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log("percentCompleted", percentCompleted);
          onProgress({ percent: percentCompleted }, option.file); // 更新进度
        }
      };
      fileAxios({
        url: '/api/file/upload',
        method: "post",
        data: params,
        onUploadProgress: progressEvent => {
          
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          
          onProgress({ percent: percentCompleted }, option.file); // 更新进度
        }
      }).then(res => {
        //
        if (res.data.retCode === "0000000") {
            if (res.data.rspBody && res.data.rspBody[0] && res.data.rspBody[0].url) {
                resolve(res.data.rspBody[0].url);
            } else {
                reject("无法获取到图片地址")
            }
        } else {
            reject(res.data.retDesc == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : res.data.retDesc)
        }
    }).catch(err => {
        reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
    });
  })
}

// 全局上传配置（可抽离到 Vue.prototype 或单独配置文件）
var globalUploadConfig = {
  maxSize: 1 * 1024 * 1024, // 1MB
  compressQuality: 0.8,
  acceptTypes: ['image/jpeg', 'image/png', 'image/webp'],
  fileList: [],
};

// 全局上传处理器
export const globalUploadHandler = async ({ file, action, onSuccess, onError, onProgress, extraData = {} }) => {

    console.log("file", file);
  try {
    // 2. 压缩图片（若需）
    const compressedFile = await compressImage(file);

    // 3. 校验压缩后大小
    // if (compressedFile.size > globalUploadConfig.maxSize) {
    //   throw new Error('文件大小超过 1MB');
    // }
    // 5. 发送请求
    console.log("compressedFile", compressedFile.name);
    var filename = compressedFile.name;
    var params = {
        filename: filename,
        file: compressedFile
    }
    const res = await upload(params, onProgress);

    // // 6. 触发成功回调
    var response = {
        rspBody: [{url: res}],
        retCode: "0000000",
    }

    
    // globalUploadConfig.fileList.push({
    //   rspBody: [{url: res}],
    //   retCode: "0000000",
    // })
    setTimeout(() => {
        onSuccess(response);
        // globalUploadConfig.fileList = [];
    }, 1000)
  } catch (err) {
    console.log("err", err);
    // 统一错误处理
    onError(err.message || '上传失败');
  }
};

// 图片压缩函数
const compressImage = (file) => {
    console.log(globalUploadConfig.compressQuality, "压缩质量")
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: globalUploadConfig.compressQuality,
      maxWidth: 1920,
      maxHeight: 1080,
      success(result) {
        if (result.size > globalUploadConfig.maxSize && globalUploadConfig.quality > 0.2) {
            globalUploadConfig.quality = globalUploadConfig.quality - 0.2
            compressImage(file);
        } else {
            resolve(new File([result], file.name, { type: result.type }));
        }
      },
      error(err) {
        reject(err);
      }
    });
  });
};


// WEBPACK FOOTER //
// ./src/utils/globalUploadHandler.js